import VExpansionPanel from './VExpansionPanel';
import VExpansionPanelContent from './VExpansionPanelContent';
export { VExpansionPanel, VExpansionPanelContent };
export default {
    $_vuetify_subcomponents: {
        VExpansionPanel: VExpansionPanel,
        VExpansionPanelContent: VExpansionPanelContent
    }
};
//# sourceMappingURL=index.js.map